import { UppyFile } from '@uppy/core';
import { Button } from 'src/components/atoms';
import { StyledIconInButton } from 'src/components/foundations/foundations.styles';
import { ButtonContainer } from '../FileUpload.styles';
import { useFileUploadContext } from '../FileUploadContext';

interface Props {
  addFilesButtonText: string;
  confirmButtonText?: string;
  onConfirm?: (files: UppyFile[]) => void;
  openFileSelect: () => void;
  files: UppyFile[];
}

export const AddMoreFilesButtons = ({
  addFilesButtonText,
  confirmButtonText,
  onConfirm,
  openFileSelect,
  files,
}: Props) => {
  const { restrictions } = useFileUploadContext();
  const showConfirmButton = !!onConfirm;

  const maxNumberOfFiles = restrictions?.maxNumberOfFiles || 10;

  return (
    <ButtonContainer>
      {files.length < maxNumberOfFiles && (
        <Button
          variant="secondary"
          onClick={openFileSelect}
          data-testid="add-more-files-button"
        >
          <StyledIconInButton
            size="medium"
            position="left"
            className="uil uil-plus"
          />
          {addFilesButtonText}
        </Button>
      )}
      {showConfirmButton && (
        <Button
          variant="primary"
          onClick={() => onConfirm(files)}
          data-testid="confirm-upload-button"
        >
          {confirmButtonText}
        </Button>
      )}
    </ButtonContainer>
  );
};
